/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.onboarding.profile

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import org.koin.compose.viewmodel.koinViewModel
import studio.oddpods.cauce.core.base.ui.EventsEffect
import studio.oddpods.cauce.core.ui.asString
import studio.oddpods.cauce.core.ui.scaffold.KptScaffold

@Composable
fun ProfileSetupScreen(
    onNavigateNext: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ProfileSetupViewModel = koinViewModel(),
) {
    val state by viewModel.stateFlow.collectAsStateWithLifecycle()

    EventsEffect(eventFlow = viewModel.eventFlow) { event ->
        when (event) {
            ProfileSetupEvent.NavigateNext -> onNavigateNext()
        }
    }

    KptScaffold(
        showNavigationIcon = false,
        title = "Configuremos tu cuenta",
        modifier = modifier,
    ) {
        Column(
            modifier = Modifier.fillMaxSize().padding(24.dp),
        ) {
            Text(
                text = "Así Cauce puede ayudarte con los cobros desde el primer día.",
                style = MaterialTheme.typography.bodyMedium,
            )
            Spacer(Modifier.height(24.dp))
            OutlinedTextField(
                value = state.displayName,
                onValueChange = { viewModel.trySendAction(ProfileSetupAction.DisplayNameChanged(it)) },
                label = { Text("Tu nombre") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
            )
            Spacer(Modifier.height(16.dp))
            OutlinedTextField(
                value = state.feeInput,
                onValueChange = { viewModel.trySendAction(ProfileSetupAction.FeeChanged(it)) },
                label = { Text("Honorario por sesión (ARS)") },
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
            )
            if (state.error != null) {
                Spacer(Modifier.height(8.dp))
                Text(state.error!!.asString(), color = MaterialTheme.colorScheme.error)
            }
            Spacer(Modifier.weight(1f))
            Button(
                onClick = { viewModel.trySendAction(ProfileSetupAction.SaveClick) },
                enabled = !state.isSaving,
                modifier = Modifier.fillMaxWidth(),
            ) { Text("Guardar y continuar") }
        }
    }
}
